import React, { useContext, useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { CategoryRevenueBenchmarkContext } from 'contexts/CategoryRevenueBenchmark';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const RevenueAboveBenchmarkExplore = () => {
	const { gridData } = useContext(CategoryRevenueBenchmarkContext);
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of categories with spend greater than median benchmarks (category spend as % of total revenue).`}
				</AnalysisDescription>
				<TableContainer>
					<AgGridTable gridOptions={gridData} gridStyle={gridStyle} />
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default RevenueAboveBenchmarkExplore;
